export enum CommonIdps {
  BASIC = 'frame-password',
  GOOGLE = 'google-oauth2',
  SAT_PROVIDER = 'sat-provider',
  NUTANIX_ADMIN = 'nutanix-frame-idp',
}
